export interface StatusEntry {
  status: string;
  date: string;
  user: string;
  description: string;
  time: string;
}

export interface JobCardForm {
  // Section 1 – auto from settings
  companyName: string;
  companyAddress: string;
  companyEmail: string;
  companyPhone: string;
  companyGstin: string;
  companyLogo: string;

  // Section 2
  jobNo: string;

  // Section 3
  assignedDate: string;
  createdDate: string;

  // Section 4
  clientId: string;
  clientName: string;
  clientCompany: string;
  clientEmail: string;
  clientPhone: string;
  clientAddress: string;
  clientDesignation: string;
  clientGstin: string;
  contactPerson: string;
  contactPersonPhone: string;

  // Section 5
  projectTitle: string;
  surveyLocation: string;

  // Section 6
  services: string[];
  customService: string;

  // Section 7
  scopeOfWork: string;

  // Section 8
  fieldTeam: string[];

  // Section 9
  officeTeam: string[];

  // Section 10
  completionDate: string;

  // Section 11
  siteConditions: string;

  // Section 12
  dataAddons: string[];

  // Section 13
  statusTimeline: StatusEntry[];
  currentStatus: string;

  // Section 14
  deliverables: string[];
  customDeliverable: string;

  // Meta
  priority: string;
  area: string;

  // Quotation linkage
  quotationType: "with_quotation" | "without_quotation";
  linkedQuotationId: string;
  linkedQuotationNo: string;

  // Field Visit
  fieldVisitRequired: boolean;
}

export const EMPTY_FORM: JobCardForm = {
  companyName: "",
  companyAddress: "",
  companyEmail: "",
  companyPhone: "",
  companyGstin: "",
  companyLogo: "",
  jobNo: "",
  assignedDate: "",
  createdDate: "",
  clientId: "",
  clientName: "",
  clientCompany: "",
  clientEmail: "",
  clientPhone: "",
  clientAddress: "",
  clientDesignation: "",
  clientGstin: "",
  contactPerson: "",
  contactPersonPhone: "",
  projectTitle: "",
  surveyLocation: "",
  services: [],
  customService: "",
  scopeOfWork: "",
  fieldTeam: [],
  officeTeam: [],
  completionDate: "",
  siteConditions: "",
  dataAddons: [],
  statusTimeline: [],
  currentStatus: "Pending",
  deliverables: [],
  customDeliverable: "",
  priority: "Medium",
  area: "",
  quotationType: "without_quotation",
  linkedQuotationId: "",
  linkedQuotationNo: "",
  fieldVisitRequired: false,
};

export const SERVICE_TYPES = [
  { label: "Topographic Survey", icon: "ri-map-2-line" },
  { label: "DGPS Survey", icon: "ri-radar-line" },
  { label: "Boundary Survey", icon: "ri-focus-3-line" },
  { label: "Soil Test", icon: "ri-flask-line" },
  { label: "As-Built Survey", icon: "ri-building-2-line" },
  { label: "Drone Survey", icon: "ri-flight-takeoff-line" },
  { label: "Revenue Survey", icon: "ri-government-line" },
  { label: "Hydrogeological Survey", icon: "ri-water-flash-line" },
  { label: "CAD Drafting", icon: "ri-pen-nib-line" },
  { label: "Custom Service", icon: "ri-add-circle-line" },
];

export const DATA_ADDONS = [
  "CAD Drawing (.dwg)",
  "GIS Shapefile (.shp)",
  "KMZ / KML File",
  "Excel Report",
  "PDF Report",
  "Contour Map",
  "3D Model",
  "Drone Orthophoto",
  "Field Photos",
  "Survey Report",
];

export const DELIVERABLE_OPTIONS = [
  "Hard Copy Report",
  "Soft Copy (PDF)",
  "CAD Drawing Files",
  "GIS Data Files",
  "KMZ/KML Files",
  "Excel Data Sheet",
  "Drone Imagery",
  "3D Point Cloud",
  "Signed Survey Report",
  "Client Presentation",
];

export const STATUS_OPTIONS = ["Pending", "In Progress", "Completed", "Delivered"];

export const PRIORITY_OPTIONS = ["Low", "Medium", "High", "Critical"];
